import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import {
  NavbarAdmin,
  NavbarUser as Navbar,
  NavbarSuperAdmin,
} from '../components/Navbar';
import Sidebar from '../components/Sidebar/Sidebar';
import SidebarAdmin from '../components/Sidebar/SidebarAdmin';
import SidebarSuperAdmin from '../components/Sidebar/SidebarSuperAdmin';
// import ButtomBar from '../components/Sidebar/BottomBar'; // ถ้าไม่ได้ใช้ก็คอมเมนต์ไว้ได้ครับ
import { ROLES } from '../utils/constants';

function DashboardLayout({ checkAccessRights }) {
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [openSidebar, setOpenSidebar] = useState(true);
  const [isMobileNavbarOpen, setIsMobileNavrbarOpen] = useState(true);

  const handleSidebarToggle = () => {
    if (window.innerWidth < 1024) {
      setMobileNavOpen((prev) => !prev);
    } else {
      setOpenSidebar((prev) => !prev);
    }
  };

  const handleMobileNavbarToggle = () => {
    setIsMobileNavrbarOpen(!isMobileNavbarOpen);
  };

  // 1. จัดการ Sidebar: ให้ SALES ใช้ Sidebar ของ SUPER_ADMIN
  const renderSidebarFromAccessibleRole = () => {
    if (checkAccessRights(ROLES.USER_ROLE)) {
      return (
        <Sidebar
          open={openSidebar}
          setOpen={setOpenSidebar}
          openMobile={isMobileNavOpen}
          onMobileClose={() => setMobileNavOpen(false)}
          // ✅ เพิ่ม prop นี้เพื่อส่งไปเช็คในไฟล์ Sidebar.js
          isSale={checkAccessRights(ROLES.SALE_ROLE)} 
        />
      );
    }
    if (checkAccessRights(ROLES.ADMIN_ROLE)) {
      return (
        <SidebarAdmin
          open={openSidebar}
          setOpen={setOpenSidebar}
          openMobile={isMobileNavOpen}
          onMobileClose={() => setMobileNavOpen(false)}
        />
      );
    }
    // ✅ นำ SALE_ROLE มารวมกับ SUPER_ADMIN_ROLE เพื่อใช้ SidebarSuperAdmin
    if (checkAccessRights(ROLES.SUPER_ADMIN_ROLE) || checkAccessRights(ROLES.SALE_ROLE)) {
      return (
        <SidebarSuperAdmin
          open={openSidebar}
          setOpen={setOpenSidebar}
          openMobile={isMobileNavOpen}
          onMobileClose={() => setMobileNavOpen(false)}
          isSale={checkAccessRights(ROLES.SALE_ROLE)}
        />
      );
    }
    return <></>;
  };

  // 2. จัดการ Navbar: ให้ SALES ใช้ Navbar ของ SUPER_ADMIN
  const renderNavbarFromAccessibleRole = () => {
    // ✅ นำ SALE_ROLE มารวมกับ SUPER_ADMIN_ROLE เพื่อใช้ NavbarSuperAdmin
    if (checkAccessRights(ROLES.SUPER_ADMIN_ROLE) || checkAccessRights(ROLES.SALE_ROLE)) {
      return (
        <NavbarSuperAdmin
          openSidebar={openSidebar}
          setOpenSidebar={setOpenSidebar}
          handleSidebarToggle={handleSidebarToggle}
          handleMobileNavbarToggle={handleMobileNavbarToggle}
          isMobileNavbarOpen={isMobileNavbarOpen}
        />
      );
    }
    if (checkAccessRights(ROLES.ADMIN_ROLE)) {
      return (
        <NavbarAdmin
          openSidebar={openSidebar}
          setOpenSidebar={setOpenSidebar}
          handleSidebarToggle={handleSidebarToggle}
          handleMobileNavbarToggle={handleMobileNavbarToggle}
          isMobileNavbarOpen={isMobileNavbarOpen}
        />
      );
    }
    if (checkAccessRights(ROLES.USER_ROLE)) {
      return (
        <Navbar
          setOpenSidebar={setOpenSidebar}
          openSidebar={openSidebar}
          handleSidebarToggle={handleSidebarToggle}
          handleMobileNavbarToggle={handleMobileNavbarToggle}
          isMobileNavbarOpen={isMobileNavbarOpen}
        />
      );
    }
    return <></>;
  };

  return (
    <div className="flex h-screen overflow-x-hidden">
      {renderSidebarFromAccessibleRole()}
      <div className="flex flex-col min-w-0 w-full overflow-y-hidden">
        {renderNavbarFromAccessibleRole()}
        <main className="flex-1 min-w-0 overflow-y-auto p-4 ">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default DashboardLayout;